import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SCRIPT_ID = "leadconnector-chat-widget";
const LOADER_SRC = "https://widgets.leadconnectorhq.com/loader.js";
const RESOURCES_URL = "https://widgets.leadconnectorhq.com/chat-widget/loader.js";
const WIDGET_ID = "6a8db71ef164fc162244b8ad";

// Carriers require the chat widget to be the ONLY element collecting phone
// numbers / SMS opt-in consent on any page it appears on. /Calendar embeds the
// LeadConnector booking iframe, which asks for a phone number, so the widget is
// kept off that route.
const EXCLUDED_PATHS = ["/calendar"];

const removeWidget = () => {
  const script = document.getElementById(SCRIPT_ID);
  if (script) {
    script.remove();
  }
  document
    .querySelectorAll("chat-widget, #chat-widget, .lc_text-widget")
    .forEach((node) => node.remove());
};

const ChatWidget = () => {
  const { pathname } = useLocation();
  const isExcluded = EXCLUDED_PATHS.includes(pathname.toLowerCase());

  useEffect(() => {
    if (isExcluded) {
      removeWidget();
      return undefined;
    }

    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.src = LOADER_SRC;
      script.async = true;
      script.dataset.resourcesUrl = RESOURCES_URL;
      script.dataset.widgetId = WIDGET_ID;
      script.dataset.source = "WEB_USER";
      document.body.appendChild(script);
    }

    return removeWidget;
  }, [isExcluded]);

  return null;
};

export default ChatWidget;
